/* DON'T EDIT THIS FILE: edit original and run build again */ import { getLoggedFirebaseUser } from "./get-logged-user.ts";

export const getLoggedUserId = () => {
  const user = getLoggedFirebaseUser();
  return user ? user.uid : null;
};
